
import { Component, Vue, Prop } from "vue-property-decorator";
import { plainToInstance } from "class-transformer";

import unit_routes from "@/api/routes/units";
import user_routes from "@/api/routes/users";

import { phases } from "@/consts";

import Upload from "@/components/Upload.vue";
import ImageView from "@/components/ImageView.vue";
import VideoView from "@/components/VideoView.vue";
import CAudioView from "@/components/audioView.vue";
import PdfView from "@/components/PdfView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import RelationVersion from "@/models/relation/version";
import UnitVersion, { EUnitableType } from "@/models/unit/unit_version";
import EventVersion from "@/models/unit/unitable/event/version";
import UserUser from "@/models/user/user";
import UnitUnit from "@/models/unit/unit";

@Component({
  name: "CProgramMaterialEvent",
  components: {
    Upload,
    CFileDownload,
    ImageView,
    VideoView,
    CAudioView,
    PdfView
  }
})
export default class CProgramMaterialEvent extends Vue {
  @Prop({ required: true }) program_id!: string;
  @Prop({ required: true }) relation!: RelationVersion;
  @Prop({ required: false, default: false }) public disabled!: boolean;

  public phases = phases.slice(1, 5);

  private accept_files: string[] = [
    "application/pdf",
    "image/jpeg",
    "image/bmp",
    "image/png",
    "video/mp4",
    "audio/mpeg",
    "audio/wav",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-excel.sheet.macroenabled.12", // xlsm MacOS|Linux
    "application/vnd.ms-excel.sheet.macroEnabled.12", //xlsm Win
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
    "application/msword", // doc
    "application/vnd.ms-excel", // xlx
    "application/vnd.ms-powerpoint", // ppt
    "application/vnd.oasis.opendocument.text", // odt
    "application/vnd.oasis.opendocument.spreadsheet", // ods
    "application/vnd.oasis.opendocument.presentation", // odp
    "application/rtf" // rtf
  ];

  public unit_version: UnitVersion | null = null;
  public edit_errors: string | null = null;
  public trainers: UserUser[] = [];

  protected async created() {
    await Promise.all([this.loadEvent(), this.loadTrainers()]);
  }

  private async loadEvent() {
    if (this.relation.unit_version_id) {
      return this.$api
        .get(unit_routes.version(this.relation.unit_version_id))
        .then(({ data: res }: { data: UnitVersion }) => {
          this.unit_version = plainToInstance(UnitVersion, res);
        });
    } else {
      this.unit_version = new UnitVersion({
        relation_version: this.relation,
        unit: new UnitUnit({ is_template: false }),
        unitable: new EventVersion(),
        unitable_type: EUnitableType["Event::Version"]
      });

      this.unit_version!.title = "Встреча";
    }
  }

  public unitable() {
    return this.unit_version?.unitable as EventVersion;
  }

  public changeFormatLeader(type: string) {
    (this.unit_version!.unitable as EventVersion).leader_file_type = type;
  }

  public changeFormatSubordinate(type: string) {
    (this.unit_version!.unitable as EventVersion).subordinate_file_type = type;
  }

  private async loadTrainers() {
    return this.$api.get(user_routes.trainers).then(res => {
      this.trainers = res.data;
    });
  }

  public async createEvent() {
    return this.$api
      .post(unit_routes.versions, {
        ...this.unit_version,
        ...{ relation: { program_id: this.program_id } }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationCreated", res);
        this.$emit("RelationAdd", true);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }

  public async updateEvent() {
    if (
      !window.confirm(
        "Вы уверены, что хотите сохранить новую редакцию материала?"
      )
    ) {
      return;
    }

    return this.$api
      .put(unit_routes.version(this.unit_version!.id), {
        ...this.unit_version,
        ...{
          relation_version: { id: this.relation.id, level: this.relation.level }
        }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationUpdated", res);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }

  public deleteSubordinateFile() {
    (this.unit_version!.unitable as EventVersion).subordinate_url = null;
  }

  public deleteLeaderFile() {
    (this.unit_version!.unitable as EventVersion).leader_url = null;
  }
}
